module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.0.2.0.box.16.494.996.1314.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.0.0.box.564.960.541.242.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "115%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.0.box.632.960.403.56.q.80"
    }
  }, [_vm._v("CAVALIER")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR1.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "107%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.1.box.718.1063.232.43.q.90"
    }
  }, [_vm._v("IN THE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR1.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "115%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.2.box.564.1146.541.56.q.90"
    }
  }, [_vm._v("WILDERNESS")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.3.0.0.box.426.841.900.91.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.0.box.681.841.396.40.q.70"
    }
  }, [_vm._v("Also By Ross Phares")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.1.box.426.892.900.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.1.0"
    }
  }), _vm._v("(All Available from Pelican Publishing Co.)")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.1.0.box.424.980.903.243.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.3.1.0.box.424.980.903.77.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.2.0"
    }
  }), _vm._v("Reverend ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Devil, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Biography ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("John ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Murrell ")]), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.3.0"
    }
  }), _vm._v("(Pelican), 1941")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.3.1.1.box.427.1063.598.36.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Texas ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tradition ")]), _vm._v("(Henry Holt), 1954")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.3.1.2.box.424.1106.903.76.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bible ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pocket, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gun ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hand: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Story ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frontier ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.4.0"
    }
  }), _vm._v("Religion ")]), _vm._v("(Doubleday), 1964")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR2.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.3.1.3.box.427.1187.662.36.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Texas ")]), _vm._v("(Pelican), 1976")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.3.0.box.418.562.870.344.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "136%",
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.0.box.518.562.666.92.q.80"
    }
  }, [_vm._v("CAVALIER")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "115%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.1.box.694.706.316.56.q.100"
    }
  }, [_vm._v("IN THE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "136%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.2.box.418.814.870.92.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.2.0"
    }
  }), _vm._v("WILDERNESS")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.4.0.box.480.1020.753.129.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.4.0.box.480.1020.753.58.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.3.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("story ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("explorer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trader ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.4.1.box.549.1095.608.54.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Louis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Juchereau ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("St ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Denis ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.5.0.box.583.1247.539.128.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.5.0.box.824.1247.57.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.4.0"
    }
  }), _vm._v("By")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.5.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "115%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.5.1.box.583.1319.539.56.q.90"
    }
  }, [_vm._v("ROSS PHARES")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.6.0.box.584.1775.530.31.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.0.box.584.1775.530.31.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.4.0.0"
    }
  }), _vm._v("A FIREBIRD PRESS BOOK")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.4.7.0.box.800.1862.92.84.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.7.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.7.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.9.0.box.611.1965.479.54.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.9.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.9.0.box.611.1965.479.21.q.90"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.9.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.9.1.box.771.1996.158.23.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.7.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.8.0.0"
    }
  }), _vm._v("Gretna 1998")]), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.10.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.13.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.0.0.box.574.658.589.282.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.0.box.716.658.302.38.q.70"
    }
  }, [_vm._v("Copyright© 1952")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.1.box.574.703.589.34.q.80"
    }
  }, [_vm._v("By Louisiana State University Press")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.0.2.box.584.742.565.38.q.60"
    }
  }, [_vm._v("Copyright © 1971 by Ross Phares")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.3.box.716.788.300.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.1.0"
    }
  }), _vm._v("All rights reserved")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.4.box.580.827.575.37.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.2.0"
    }
  }), _vm._v("ISBN (hard cover): 0-88289-128-6")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.5.box.581.869.570.38.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.3.0"
    }
  }), _vm._v("ISBN (paperback): 0-88289-127-8")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.6.box.747.913.240.27.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.4.0"
    }
  }), _vm._v("LCN: 76-1409")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.1.0.box.614.1017.528.118.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.0.box.656.1017.450.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.5.0"
    }
  }), _vm._v("First Printing, March, 1952")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.1.box.614.1058.528.36.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.6.0"
    }
  }), _vm._v("Second Printing, October, 1968")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.2.box.656.1101.443.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.7.0"
    }
  }), _vm._v("Third Printing, June, 1976")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.2.0.box.564.1916.584.101.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.2.0.box.572.1916.565.20.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.0.0"
    }
  }), _vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.2.1.box.567.1960.574.27.q.70"
    }
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.2.2.box.564.1993.584.24.q.70"
    }
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.706.1031.275.49.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.0.box.706.1031.275.49.q.70"
    }
  }, [_vm._v("To My Wife")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR6"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a152449a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0003.vue
// module id = 54
// module chunks = 0